module.exports = [
    {
        orgSlug: 'gala',
        coachCompanyId: 1
    },
    {
        orgSlug: 'getboarded',
        coachCompanyId: 2
    }
];